import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { genericSort } from "@notemeal/utils-sort";
export const ScheduleContainer = (props) => {
    return (_jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, ...props.sx }, children: sortedScheduleComponents(props).map(({ component, id }) => (_jsx(Box, { children: component }, id))) }));
};
export const sortedScheduleComponents = ({ meals, activities, mealToStart, activityToStart, renderMeal, renderActivity, }) => {
    const mealComponents = meals.map(m => ({
        component: renderMeal(m),
        start: mealToStart(m),
        id: m.id,
    }));
    const activityComponents = activities.map(a => ({
        component: renderActivity(a),
        start: activityToStart(a),
        id: a.id,
    }));
    return [...mealComponents, ...activityComponents].sort((a, b) => genericSort(a.start, b.start));
};
//# sourceMappingURL=Container.js.map